export default {
      id: "plug-usage",
      viewBox: "0 0 32 32",
      url: __webpack_public_path__ + "sprite.svg#plug-usage",
      toString: function () {
        return this.url;
      }
    }